export const supportedDocuments = {
  supported_documents: `Documentos de apoyo`,
  document_name: `Nombre del documento`,
  expiry_date: `Fecha de vencimiento`,
  upload_support_document: `Subir documento de soporte`,
  upload_prefix: `Subir`,
  upload_and_manage_support_documents: `Subir y gestionar documentos de soporte`,
  set_document_expiry: `Establecer fecha de caducidad del documento`,
  partyDocument_expires_on: `Caduca el {{expiryDate}}`,
  delete_document: `Eliminar documento`,
  this_action_cannot_be_undone: `Esta acción no se puede deshacer`,
  previous_page: `Página anterior`,
  next_page: `Página siguiente`,
  suppler_document_expired: `El documento de soporte del proveedor ha expirado`,
  update_support_document_in_profile_page: `Por favor, actualice el documento de soporte desde la página de perfil del proveedor.`,
  document_updated_successfully: `Documento actualizado correctamente`,
  document_uploaded_successfully: `Documento cargado correctamente`,
  document_deleted_successfully: `Documento eliminado correctamente`,
  update_document: `Actualizar documento`,
  save_document: `Guardar documento`,
  partyDocument_expired_on: `Expiró el {{expiryDate}}`,
  expiry_date_is_required: `La fecha de vencimiento es obligatoria`,
  document_expiry_date_required: `Se requiere la fecha de vencimiento del documento`,
  document_can_only_be_updated_3_days_before_expiry_or_after_expiry: `El documento solo se puede actualizar 3 días antes de su vencimiento o después de su vencimiento`,
  expiry_date_cannot_be_less_than_current_date: `La fecha de vencimiento no puede ser anterior a la fecha actual`,
  upload_new: `Subir nuevo`,
  profile_updated: `Perfil actualizado`,
};
